import { Children, cloneElement, Component, isValidElement } from 'react';
import invariant from '../tiny-invariant';
import warning from '../tiny-warning';
import RouterContext from './RouterContext';
import matchPath from './matchPath';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The public API for rendering the first <Route> that matches.
 */
class Switch extends Component {
  render() {
    return /*#__PURE__*/_jsx(RouterContext.Consumer, {
      children: context => {
        invariant(context, 'You should not use <Switch> outside a <Router>');
        const location = this.props.location || context.location;
        let element = null;
        let matched = null;

        // We use Children.forEach instead of Children.toArray().find()
        // here because toArray adds keys to all child elements and we do not want
        // to trigger an unmount/remount for two <Route>s that render the same
        // component at different URLs.
        Children.forEach(this.props.children, child => {
          if (matched == null && /*#__PURE__*/isValidElement(child)) {
            element = child;
            const path = child.props.path || child.props.from;
            matched = path ? matchPath(location.pathname, Object.assign({}, child.props, {
              path
            })) : context.match;
          }
        });
        return matched ? /*#__PURE__*/cloneElement(element, {
          location,
          computedMatch: matched
        }) : null;
      }
    });
  }
}
if (process.env.NODE_ENV !== 'production') {
  Switch.prototype.componentDidUpdate = function (prevProps) {
    warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };
}
export default Switch;